function showForm(formConfig, config = {}) {
  const { formId, parentPageId, params } = formConfig;
  const { version = 'v1', app, url: customUrl, callBackId } = config;
  if (!version && !customUrl) {
    throw new Error('version in config is required');
  }

  if (!app && !customUrl) {
    throw new Error('app in config is required');
  }

  if (!formId && !customUrl) {
    throw new Error('formId is required');
  }

  let url = customUrl || `${location.pathname}kwc/${version}/kd/${app}/kwcform/${formId}/showconfig`;

  if (!customUrl && parentPageId) {
    url = `${url}?parentPageId=${parentPageId}`;
  }

  if (params && Object.keys(params).length > 0) {
    try {
      const _params = JSON.stringify(params);
      const sign = url.includes('?') ? '&' : '?'
      url = `${url}${sign}params=${_params}`
    } catch (error) {
      console.error(error);
    }
  }

  if (callBackId) {
    const sign = url.includes('?') ? '&' : '?'
    url = `${url}${sign}callBackId=${callBackId}`
  }

  return new Promise((resolve, reject) => {
    fetch(url).then(response => {
      return response.json();
    }).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
}

export default showForm;
